export default __webpack_public_path__ + "static/prediction-3719db50647f32b703dfdbf5db9f8248.png";